import { HttpParams, HttpProgressEvent } from '@angular/common/http';
import { IErrorResponse } from '@sb/library/data-models';
import { Observable, ReplaySubject, Subject } from 'rxjs';
import { ColumnOf, OrderBy, PaginatorData } from './table.definitions';

export enum RequestKind {
    Post = 'post',
    Get = 'get',
    Patch = 'patch',
    Put = 'put',
    Delete = 'delete'
}

export enum ProgressKind {
    None,
    Upload,
    Computation
}

export interface OneParameterRequired {
    Parameter: string;
}

export interface TwoParametersRequired {
    Parameter1: string;
    Parameter2: string;
}
export interface ThreeParametersRequired {
    Parameter1: string;
    Parameter2: string;
    Parameter3: string;
}

export interface BodyRequired<T> {
    Body: T;
}

export interface PaginatorDataOptional {
    PaginatorData?: PaginatorData;
}

export interface OrderByOptional<T> {
    OrderBy?: OrderBy<T>;
}

export interface RequestedFieldsOptional<T> {
    RequestedFields?: RequestedField<T>[];
}

export interface ExtraQueryParametersOptional<T extends string> {
    ExtraQueryParameters?: ExtraQueryParameter<T>;
}

export interface IRequestOptions extends
    Partial<OneParameterRequired>, Partial<TwoParametersRequired>, Partial<ThreeParametersRequired>, Partial<BodyRequired<any>>,
    PaginatorDataOptional, OrderByOptional<any>, RequestedFieldsOptional<any>, ExtraQueryParametersOptional<any> {
}

export interface IApiRequest<T = any> {
    URL: string,
    Kind: RequestKind,
    Body?: T,
    HttpParams: HttpParams
}

export interface CancellableObservable<T> extends Observable<T> {
    Cancel(): void;
    Progress?: Subject<number>;
}

export type ApiSubject<T, U> = Subject<ApiResult<T, U>>;
export type ApiReplaySubject<T, U> = ReplaySubject<ApiResult<T, U>>;
export type ApiObservable<T, U> = Observable<ApiResult<T, U>>;
export type ApiProgressSubject<T> = Subject<ApiResult<HttpProgressEvent, T>> & {
    Upload?: boolean;
    Computation?: boolean;
};

export class ApiResult<Response, Request> {
    Request!: Request;
    Response!: Response;

    constructor(initializer: ApiResult<Response, Request>) {
        Object.assign(this, initializer);
    }
}

export class ApiError<Request> extends ApiResult<IErrorResponse, Request> {
    Status!: number;
    Message!: string;

    constructor(initializer: ApiError<Request>) {
        super(initializer);
    }
}

export class RequestedField<T> {
    Field!: ColumnOf<T>;
    Value?: string;

    constructor(initializer: RequestedField<T>) {
        Object.assign(this, initializer);
    }
}

export type ExtraQueryParameter<T extends string> = {
    [x in T]?: string | null;
}
